function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent, computed, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import IconLanguage from "@/components/IconLanguage/index.vue";
import { formatLabel } from "@/components/IconLanguage/utils";
export default defineComponent({
    name: "PsLanguageSelect",
    components: {
        IconLanguage: IconLanguage
    },
    props: {
        value: String,
        data: {
            type: definePropType(Array),
            required: true
        },
        placeholder: definePropType(String)
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var languageList = computed(function() {
            return root.$store.state.config.languages || [];
        });
        var mapData = function(data, list) {
            return data.map(function(group) {
                return _objectSpreadProps(_objectSpread({}, group), {
                    options: group.options.map(function(option) {
                        var code = option.value;
                        var item = list.find(function(t) {
                            return t.code === code;
                        });
                        return _objectSpreadProps(_objectSpread({}, option), {
                            label: formatLabel(code, item ? item.name : code)
                        });
                    })
                });
            });
        };
        if (!languageList.value.length) {
            root.$store.dispatch("config/getLanguagesList");
        }
        return {
            languageList: languageList,
            mapData: mapData
        };
    }
});
